/* eslint-disable */
/**
 * GENERATED FILE, DO NOT EDIT.
 *
 * Source:    design-system/glyphs/*.svg
 * Regenerate: node design-system/build.mjs
 *
 * A hand edit here is reverted by the next build and fails the drift test in
 * CI. Change the token source instead: that is what keeps the accent one
 * value across four surfaces instead of four values across four surfaces.
 */

/** Drawn for Beast, in design-system/glyphs/*.svg, and compiled into the console rather than fetched: art that 404s paints nothing and nothing reports it. It exists for the marks no pack can carry: the frunk and the trunk, the two a pack can only answer with a container, Beast Bucks, a currency no pack has heard of, and the car wash, which neither pack draws */
export const BEAST_GLYPH_PREFIX = 'beast'

/** The unit grid every drawn glyph is on, so the wrapper's stroke maths holds. */
export const BEAST_GLYPH_VIEW_BOX = '0 0 24 24'

/**
 * The drawing of each glyph, as the pack wrapper hands it over: a stroked
 * group on 24 units, which is the same shape a Lucide or Tabler body
 * arrives in, so one renderer draws all three.
 */
export const BEAST_GLYPHS = {
  'bucks': "<g fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n    <rect x=\"2\" y=\"5\" width=\"20\" height=\"14\" rx=\"3\"/>\n    <path d=\"M6.75 8.5v7M6.75 8.5h2a1.75 1.75 0 0 1 0 3.5h-2M6.75 12H9a1.75 1.75 0 0 1 0 3.5H6.75\"/>\n    <path d=\"M13.25 8.5v7M13.25 8.5h2a1.75 1.75 0 0 1 0 3.5h-2M13.25 12h2.25a1.75 1.75 0 0 1 0 3.5h-2.25\"/>\n  </g>",
  'car-wash': "<g fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n    <path d=\"M5 12.5l1.5-3.7A2 2 0 0 1 8.4 7.5h7.2a2 2 0 0 1 1.9 1.3l1.5 3.7\"/>\n    <rect x=\"3\" y=\"12.5\" width=\"18\" height=\"7\" rx=\"2\"/>\n    <path d=\"M7 16h.01M17 16h.01M5 19.5v2M19 19.5v2\"/>\n    <path d=\"M9 1c-.45.75-1.1 1.4-1.1 2.25a1.1 1.1 0 0 0 2.2 0C10.1 2.4 9.45 1.75 9 1Z\"/>\n    <path d=\"M15 1c-.45.75-1.1 1.4-1.1 2.25a1.1 1.1 0 0 0 2.2 0C16.1 2.4 15.45 1.75 15 1Z\"/>\n  </g>",
  'frunk': "<g fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n    <path d=\"M9.5 3h5A3.5 3.5 0 0 1 18 6.5v11a3.5 3.5 0 0 1-3.5 3.5h-5A3.5 3.5 0 0 1 6 17.5v-11A3.5 3.5 0 0 1 9.5 3Z\"/>\n    <path d=\"M4.9 7v2.6M19.1 7v2.6M4.9 14.4v2.6M19.1 14.4v2.6\"/>\n    <path d=\"M6.4 8.6h11.2\"/>\n    <path d=\"M10 6.6 12 4.6l2 2\"/>\n  </g>",
  'trunk': "<g fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n    <path d=\"M9.5 3h5A3.5 3.5 0 0 1 18 6.5v11a3.5 3.5 0 0 1-3.5 3.5h-5A3.5 3.5 0 0 1 6 17.5v-11A3.5 3.5 0 0 1 9.5 3Z\"/>\n    <path d=\"M4.9 7v2.6M19.1 7v2.6M4.9 14.4v2.6M19.1 14.4v2.6\"/>\n    <path d=\"M6.4 15.4h11.2\"/>\n    <path d=\"M10 17.4 12 19.4l2-2\"/>\n  </g>",
} as const satisfies Record<string, string>

export type BeastGlyphName = keyof typeof BEAST_GLYPHS

/** Whether a glyph name is drawn here rather than fetched from a pack. */
export const isBeastGlyph = (icon: string): boolean =>
  icon.startsWith(`${BEAST_GLYPH_PREFIX}:`) &&
  icon.slice(BEAST_GLYPH_PREFIX.length + 1) in BEAST_GLYPHS

/**
 * The drawing behind a `${BEAST_GLYPH_PREFIX}:` name, or undefined for a name
 * this pack does not hold. Returning undefined rather than throwing is what
 * keeps the wrapper's two paths symmetrical: a pack name it cannot resolve
 * draws nothing either, and neither is a reason to take a screen down.
 */
export const beastGlyphBody = (icon: string): string | undefined =>
  BEAST_GLYPHS[icon.slice(BEAST_GLYPH_PREFIX.length + 1) as BeastGlyphName]
